
import { FirearmPoolEntityDecorator } from './firearm-pool.decorator';
import { FirearmPool } from './firearm-pool.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmPoolTypeInfoBase implements CrudTypeInfo<FirearmPool, number> {
  name = 'Firearm Pool';
  entityDecorator = new FirearmPoolEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_POOL'];
  editAuthorities = ['WRITE_FIREARM_POOL'];
  deleteAuthorities = ['DELETE_FIREARM_POOL'];
  viewAuthorities = ['READ_FIREARM_POOL'];
  
  searchRouteBase = ['/firearmpool/search'];
  createRouteBase = ['/firearmpool/create'];
  editRouteBase = ['/firearmpool/edit'];
  viewRouteBase = ['/firearmpool/view'];
  
  description(item: FirearmPool): string {
    return '' +  item.firearmAssetId;
  }
}



